import React from 'react';

const Terms = () => {
  return (
    <div className="bg-white">
      {/* Hero */}
      <section className="bg-gray-900 text-white py-20">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-5xl font-bold mb-4">Conditions Générales de Vente</h1>
          <p className="text-xl">Conditions applicables à toute commande</p>
        </div>
      </section>

      {/* Content */}
      <section className="container mx-auto px-4 py-16">
        <div className="max-w-4xl mx-auto prose prose-lg">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">1. Objet</h2>
          <p className="text-gray-700 mb-4">
            Les présentes Conditions Générales de Vente (CGV) régissent les relations contractuelles entre NEOMAT, 
            marque NEOPLIAGE, et tout client passant commande via le site www.neopliage.fr.
          </p>

          <h2 className="text-3xl font-bold text-gray-900 mb-6 mt-12">2. Produits</h2>
          <p className="text-gray-700 mb-4">
            Les produits proposés sont ceux qui figurent sur le site www.neopliage.fr. Chaque produit est accompagné 
            d'un descriptif établi par NEOPLIAGE. Les photographies ne sont pas contractuelles.
          </p>
          <p className="text-gray-700 mb-4">
            NEOPLIAGE se réserve le droit de modifier à tout moment l'assortiment de produits.
          </p>

          <h2 className="text-3xl font-bold text-gray-900 mb-6 mt-12">3. Prix</h2>
          <p className="text-gray-700 mb-4">
            Les prix sont indiqués en euros, toutes taxes comprises (TTC). NEOPLIAGE se réserve le droit de modifier 
            ses prix à tout moment, étant entendu que le prix figurant au catalogue le jour de la commande sera le seul applicable.
          </p>
          <p className="text-gray-700 mb-4">
            Les frais de livraison sont offerts pour toute commande supérieure à 500€. En dessous de ce montant, 
            des frais de livraison seront facturés selon le poids et la destination.
          </p>

          <h2 className="text-3xl font-bold text-gray-900 mb-6 mt-12">4. Commande</h2>
          <p className="text-gray-700 mb-4">
            Toute commande passée sur le site www.neopliage.fr suppose l'adhésion aux présentes CGV. 
            La validation de votre commande vaut acceptation de ces conditions.
          </p>
          <p className="text-gray-700 mb-4">
            NEOPLIAGE se réserve le droit d'annuler ou de refuser toute commande d'un client avec lequel il existerait 
            un litige relatif au paiement d'une commande antérieure.
          </p>

          <h2 className="text-3xl font-bold text-gray-900 mb-6 mt-12">5. Paiement</h2>
          <p className="text-gray-700 mb-4">
            Le paiement s'effectue par carte bancaire ou virement bancaire. Les paiements sont sécurisés.
          </p>
          <p className="text-gray-700 mb-4">
            Pour les professionnels, un paiement par chèque ou virement avec conditions de règlement peut être convenu.
          </p>

          <h2 className="text-3xl font-bold text-gray-900 mb-6 mt-12">6. Livraison</h2>
          <p className="text-gray-700 mb-4">
            Les délais de livraison indiqués sont des délais moyens indicatifs. NEOPLIAGE s'engage à livrer les produits 
            dans un délai maximum de 15 jours ouvrés à compter de la validation de la commande.
          </p>
          <p className="text-gray-700 mb-4">
            Les livraisons sont effectuées à l'adresse indiquée par le client lors de la commande. Il appartient au client 
            de vérifier l'état des produits à la réception et de signaler toute anomalie dans les 48 heures.
          </p>

          <h2 className="text-3xl font-bold text-gray-900 mb-6 mt-12">7. Droit de rétractation</h2>
          <p className="text-gray-700 mb-4">
            Conformément à l'article L221-18 du Code de la consommation, vous disposez d'un délai de 14 jours à compter 
            de la réception des produits pour exercer votre droit de rétractation sans avoir à justifier de motifs.
          </p>
          <p className="text-gray-700 mb-4">
            Les produits fabriqués sur-mesure ne sont pas soumis au droit de rétractation conformément à l'article L221-28 
            du Code de la consommation.
          </p>

          <h2 className="text-3xl font-bold text-gray-900 mb-6 mt-12">8. Garantie</h2>
          <p className="text-gray-700 mb-4">
            Tous nos produits bénéficient de la garantie légale de conformité (articles L217-4 et suivants du Code de la consommation) 
            et de la garantie contre les vices cachés (articles 1641 et suivants du Code civil).
          </p>
          <p className="text-gray-700 mb-4">
            Nos produits en aluminium sont garantis contre les défauts de fabrication pendant une durée de 2 ans à compter de la livraison.
          </p>

          <h2 className="text-3xl font-bold text-gray-900 mb-6 mt-12">9. Responsabilité</h2>
          <p className="text-gray-700 mb-4">
            NEOPLIAGE ne saurait être tenue responsable de l'inexécution du contrat en cas de rupture de stock, 
            indisponibilité du produit, ou force majeure.
          </p>

          <h2 className="text-3xl font-bold text-gray-900 mb-6 mt-12">10. Données personnelles</h2>
          <p className="text-gray-700 mb-4">
            Les informations recueillies font l'objet d'un traitement informatique destiné à la gestion des commandes. 
            Conformément au RGPD, vous disposez d'un droit d'accès, de rectification et de suppression de vos données.
          </p>

          <h2 className="text-3xl font-bold text-gray-900 mb-6 mt-12">11. Litige</h2>
          <p className="text-gray-700 mb-4">
            Les présentes CGV sont soumises au droit français. En cas de litige, une solution amiable sera recherchée 
            avant toute action judiciaire. À défaut, les tribunaux français seront seuls compétents.
          </p>

          <h2 className="text-3xl font-bold text-gray-900 mb-6 mt-12">12. Contact</h2>
          <p className="text-gray-700 mb-4">
            Pour toute question relative aux présentes CGV, vous pouvez nous contacter :
          </p>
          <p className="text-gray-700 mb-4">
            Par email : contact@neopliage.fr<br />
            Par téléphone : 06.37.06.03.16<br />
            Par courrier : NEOMAT - NEOPLIAGE, 23 Avenue de la Libération, 01500 Ambérieu-en-Bugey
          </p>

          <p className="text-gray-700 mt-12">
            <em>Dernière mise à jour : Février 2025</em>
          </p>
        </div>
      </section>
    </div>
  );
};

export default Terms;
